import AgingReportList from "../components/AgingReportList/AgingReportList";

export default function AgingReportsPage() {
    return <AgingReportList />;
}
